import { Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '@ngx-translate/core';
import { Dialog } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SpeechService } from '../../core/services/speech.service';

@Component({
  selector: 'app-voice-load-dialog',
  imports: [Dialog, ProgressSpinnerModule, TranslatePipe],
  templateUrl: './voice-load-dialog.component.html',
  styleUrl: './voice-load-dialog.component.css'
})
export class VoiceLoadDialogComponent {
  private readonly speechService = inject(SpeechService);
  public loading = signal(false);

  constructor() {
    this.speechService.isProcessorBusy$.pipe(takeUntilDestroyed())
      .subscribe(busy => {
        this.loading.set(busy);
      });
  }
}
